export const truncWithPrecision = (value: number): number => {
  const [match] = `${value}`.match(/^-?\d+(?:\.\d{0,2})?/) || [];
  return +(match || 0);
};
